import { AfterViewInit, Directive, ElementRef, Input, Renderer2, SimpleChanges } from '@angular/core';
import { delay } from 'cypress/types/bluebird';
import { timer } from 'rxjs';

@Directive({
  selector: '[appTruncateText]'
})
export class TruncateTextDirective implements AfterViewInit  {

  @Input() dynamicMaxWidthPercentage: number = 100; // Valor padrão, em porcentagem

  @Input() appTruncateText: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    console.log("constructor => ", this.el.nativeElement.offsetParent.offsetWidth)
  }

  ngAfterViewInit() {
      let span = this.el.nativeElement;

     if(span.children.length <= 0) {
      let textSpan = new String(span.textContent);
      let tdW = this.el.nativeElement.offsetParent.offsetWidth;
      let spanW = this.el.nativeElement.offsetWidth;
      let fakeSpan = this.renderer.createElement('span');
      document.body.appendChild(fakeSpan);
      let style = window.getComputedStyle(this.el.nativeElement.offsetParent);
      const paddingLeft = parseFloat(style.paddingLeft);
      const paddingRight = parseFloat(style.paddingRight);
      let truncatedText = '';
      console.log(textSpan + ' => ' + tdW + ' => ' + (tdW - paddingLeft - paddingRight - 20));
      for(let i = 0; i < textSpan.length; i++) {
        fakeSpan.textContent += textSpan[i];
        if(fakeSpan.offsetWidth >= (tdW - paddingLeft - paddingRight - 20)) {
         truncatedText += '...';
          break;
        }
  
        truncatedText += textSpan[i];
      }
      console.log(truncatedText);
  
      document.body.removeChild(fakeSpan);
      this.el.nativeElement.textContent = truncatedText;
    } 
    
    //this.el.nativeElement.textContent = truncatedText;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dynamicMaxWidthPercentage']) {
      this.truncateText();
    }
  }

  isTextoQuebrado(elemento: any) {
    // Obtém o estilo computado do elemento
    var estiloComputado = window.getComputedStyle(elemento);

    // Obtém a largura real do conteúdo do texto
    var larguraReal = elemento.scrollWidth;

    // Obtém a largura do contêiner do elemento
    var larguraConteiner = parseInt(estiloComputado.getPropertyValue('width'));

    // Verifica se o texto está quebrado
    return larguraReal > larguraConteiner;
}

  private truncateText() {
    const element = this.el.nativeElement;
    console.log('truncateText:' ,element.offsetWidth)
  }

  private adicionarElipseSeNecessario() {
    const elemento = this.el.nativeElement;
    var estiloComputado = window.getComputedStyle(elemento);

    // Obtém a largura real do conteúdo do texto
    const larguraReal = elemento.offsetWidth;

    // Obtém a largura do contêiner do elemento
    const larguraConteiner = parseInt(estiloComputado.getPropertyValue('width'));
    console.log("elemento: ", this.el);
    console.log("larguraReal: ", larguraReal);
    console.log("overflow: ", estiloComputado.getPropertyValue('overflow'));
    console.log("larguraConteiner: ", larguraConteiner);
    // Verifica se o texto está quebrado
    if (larguraReal > (larguraConteiner + 5)) {
      // Adiciona "..." ao final do texto usando Renderer2
      const textoOriginal = elemento.textContent;
      const textoComElipse = textoOriginal + '...';

      // Atualiza o conteúdo do elemento com "..."
      this.renderer.setProperty(elemento, 'textContent', textoComElipse);
    }
  }

}
